var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 34,
    viewBox: "0 0 16 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.974897 15.3512L10.0249 0.878616C10.6504 -0.121694 11.7131 -0.156093 12.395 0.801897L14.0513 3.10461C14.7402 4.06237 14.7915 5.64549 14.1656 6.63539L7.75076 16.8939L14.8156 26.7161C15.5045 27.6738 15.5558 29.2569 14.9299 30.2468L13.4337 32.6724C12.8081 33.6728 11.7454 33.7071 11.0635 32.7492L1.09651 18.8922C0.400626 17.9346 0.349382 16.3515 0.974897 15.3512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.fa377e2e1bb8a678ec471295c75b701f.svg";
export { ForwardRef as ReactComponent };